import Scriba from 'react-scriba';

export class DataLot {

    static _listeDesLOTS = (idOperation, inclureLotsReserves) => {
        const objet = { idOperation, inclureLotsReserves };
        const url = "api/Liste/ListeDesLOTS";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementLotsOperation(idOperation) {
        let objet = {
            "idOperation": idOperation
        };

        var url = "api/Get/GetLotsOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementLot(idLot) {
        let objet = {
            "idLot": idLot
        };

        var url = "api/Get/GetLot";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementGrilleDePrixLots(idLotCommercial) {
        let objet = {
            "idLotCommercial": idLotCommercial
        };

        var url = "api/Liste/ListeGrilleDePrixLot";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    //static _chargementLotsParNature(idNature) {
    //    let objet = {
    //        "idNature": idNature
    //    };

    //    var url = "api/Get/GetLotsParNature";
    //    var paramPost = Scriba.fetch().createParameterPost(objet);

    //    return fetch(url, paramPost).then(response => response.json());
    //}

    static _onEnregistrementLot(lot, idLot) {
        let objet = {
            "lot": lot,
            "idLot": idLot
        }

        var url = "api/MAJDonnees/EnregistrementLot";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onAssociationLots_Creation = (lots, lotCommercial, listLotCommercialTVACas) => {
        const objet = { lots, lotCommercial, listLotCommercialTVACas };
        const url = "api/MAJDonnees/EnregistrementAssociationLots_Creation";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onAssociationLots_Modification = (lots, lotCommercial, listLotCommercialTVACas) => {
        const objet = { lots, lotCommercial, listLotCommercialTVACas };
        const url = "api/MAJDonnees/EnregistrementAssociationLots_Modification";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onDissociationLots(listLots, suppressionLotCommercial) {
        let objet = {
            "lots": listLots,
            "suppressionLotCommercial": suppressionLotCommercial
        }

        var url = "api/MAJDonnees/EnregistrementDissociationLots";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onRegroupementLots(listLots) {
        let objet = {
            "lots": listLots
        }

        var url = "api/MAJDonnees/EnregistrementRegroupementLots";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onDegroupementLots(listLots) {
        let objet = {
            "lots": listLots
        }

        var url = "api/MAJDonnees/EnregistrementDegroupementLots";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onCalculPrixLots(listLots, actionCalcul) {
        let objet = {
            "lots": listLots,
            "actionCalcul": actionCalcul
        }

        var url = "api/MAJDonnees/EnregistrementCalculPrixLots";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}